var map = {
	"./ai-role-play-active.svg": "0f67",
	"./ai-role-play-inactive.svg": "ba4c",
	"./assessment-active.svg": "6f8b",
	"./assessment-inactive.svg": "badd",
	"./assignment-active.png": "3657",
	"./assignment-inactive.svg": "332a",
	"./assignment-skill-active.svg": "a84b",
	"./assignment-skill-inactive.svg": "1495",
	"./assignment-success.png": "53d5",
	"./assignment-topic-active.svg": "c9f6",
	"./assignment-topic-inactive.svg": "db61",
	"./average-score.svg": "aaba",
	"./bg-assignment.png": "797b",
	"./bg-study-sets.svg": "d4e8",
	"./books.png": "9e44",
	"./books.svg": "8c28",
	"./camera-icon-white.svg": "dbe6",
	"./card-icons.svg": "77d9",
	"./chart__book-library.svg": "ff1a",
	"./chart__clock.svg": "8c18",
	"./check-blue.svg": "1212",
	"./chevron-left-black.svg": "05ea",
	"./chevron-right-white.svg": "ccf6",
	"./class-blue.svg": "ecad",
	"./class-white.svg": "8f5f",
	"./clock.svg": "127c",
	"./company.svg": "439a",
	"./confirm-email.svg": "6a48",
	"./copy-paste-emails.svg": "a994",
	"./create-class-no-bg.svg": "ba60",
	"./create-class.svg": "6969",
	"./default-topic-bg.svg": "3b62",
	"./download-app-store.svg": "11b9",
	"./download-google.svg": "529ae",
	"./elsa-dashboard-logo.svg": "f178",
	"./elsa-login-pic.svg": "63c9",
	"./elsa-login-pic2.png": "06a0",
	"./elsa-logo-2.svg": "03ab",
	"./elsa-logo-3.svg": "7d99",
	"./elsa-logo.svg": "220b",
	"./error-icon.svg": "e0dd",
	"./facebook-logo.svg": "9647",
	"./flags.png": "1c72",
	"./flags@2x.png": "0974",
	"./game-type-assessment.svg": "68dd",
	"./game-type-conversation.svg": "139f",
	"./game-type-listen.svg": "ba1e",
	"./game-type-missing-character.svg": "94bb",
	"./game-type-pronunciation.svg": "1a39",
	"./game-type-read-aloud.svg": "c3d3",
	"./game-type-sentence-stress.svg": "fa01",
	"./game-type-unscramble-word.svg": "f90e",
	"./game-type-video-conversation.svg": "3638",
	"./game-type-vocabulary.svg": "0697",
	"./game-type-word-stress.svg": "2001",
	"./goals-days-practice.svg": "3113",
	"./goals-minutes-day.svg": "4e60",
	"./google-logo.svg": "62de",
	"./header-image.svg": "398d",
	"./ic.svg": "8c90",
	"./import-blue.svg": "f096",
	"./import-emails.svg": "ef79",
	"./import.svg": "703f",
	"./inline.active-icon.svg": "1b3c",
	"./inline.admins.svg": "d826",
	"./inline.all-classes-icon.svg": "2a35",
	"./inline.all-icon.svg": "8aab",
	"./inline.book-icon.svg": "0d12",
	"./inline.curriculum-icon.svg": "f957",
	"./inline.curriculum-image.svg": "2c23",
	"./inline.dashboard-icon.svg": "cf07",
	"./inline.disable-icon.svg": "4f88",
	"./inline.draft-icon.svg": "180c",
	"./inline.finished-icon.svg": "cf16",
	"./inline.game_types.svg": "f9ca",
	"./inline.groups-icon.svg": "705a",
	"./inline.licences-icon.svg": "4918",
	"./inline.non-verified-icon.svg": "8674",
	"./inline.not-started-icon.svg": "7cc9",
	"./inline.organization-icon.svg": "0582",
	"./inline.overview.svg": "23610",
	"./inline.payment-icon.svg": "4c8b",
	"./inline.profile-icon.svg": "326b",
	"./inline.reports.svg": "a3de",
	"./inline.rocket-icon.svg": "75e0",
	"./inline.setting-icon.svg": "a290",
	"./inline.skill.svg": "1c78",
	"./inline.students.svg": "1089",
	"./inline.teachers.svg": "e1e7",
	"./inline.team-icon-big.svg": "77f7d",
	"./inline.team-icon.svg": "3ceb",
	"./inline.team-lead-icon.svg": "32be",
	"./inline.topic.svg": "38bf",
	"./inline.user-icon-big.svg": "75dd",
	"./inline.users-icon.svg": "caeb",
	"./inline.verified-icon.svg": "cb74",
	"./insights-full.png": "f18e",
	"./invitation-code-no-bg.svg": "77bd",
	"./invitation-code.svg": "6cf3",
	"./invite-students.svg": "291c",
	"./john.png": "4f2d",
	"./link-blue.svg": "9c74",
	"./mail-blue.svg": "6c02",
	"./month-icon.svg": "92b7",
	"./no-invitation-code.svg": "11aa",
	"./no-pro-licence.svg": "f292",
	"./no-study-set.svg": "355e",
	"./notebook.svg": "93a4",
	"./org-example.png": "c2dd",
	"./plus-blue.svg": "0c4c",
	"./pro-licence.svg": "d55f",
	"./pro-licences-disable.svg": "2b40",
	"./pro-licences-enable.svg": "e312",
	"./read-aloud-active.svg": "63d1",
	"./read-aloud-inactive.svg": "4093",
	"./recover-password.svg": "30ef",
	"./school.svg": "77eb",
	"./select-email-list.svg": "5232",
	"./send-email-link.svg": "acd8",
	"./send-sms-link.svg": "047f",
	"./share-link.svg": "6109",
	"./sign.svg": "6bac",
	"./skill-listening.svg": "5b7e",
	"./skill-reading.svg": "aaa1",
	"./skill-speaking.svg": "e714",
	"./skill-writing.svg": "1703",
	"./student.svg": "d24f",
	"./students-class.svg": "a6ce",
	"./students-group.svg": "ca96",
	"./study-mode-faq-1.png": "3103",
	"./study-mode-faq-2.png": "860e",
	"./study-mode-faq-3.png": "d5f8",
	"./study-mode-faq-4.png": "6cf3d",
	"./study-mode-faq-5.png": "2de5",
	"./study-mode-header.svg": "fed9",
	"./study-set.png": "a67e",
	"./studyset-active.png": "7198",
	"./studyset-creativity.svg": "7f27",
	"./studyset-inactive.svg": "0101",
	"./task-list.svg": "b48c",
	"./teach-myself.svg": "5d41",
	"./teacher.svg": "8132",
	"./tick-disabled.svg": "d103",
	"./tick.svg": "f273",
	"./tooltip.svg": "0234",
	"./welcome-elsa.svg": "2b23",
	"./welcome-illustration.svg": "f074",
	"./yes-invitation-code.svg": "b5a8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";